import { IconDefinition, SizeProp } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const iconColor = {
  white: 'white',
  primary: '#7E8299',
  lightGray: '#E4E6EF',
  darkPrimary: '#3F4254',
  secondary: '#3F4354',
  tertiary: '#1867be',
  muted: '#B5B5C4', // "muted-foreground"
  aiGenerated: '#8F0CBB',
  success: 'hsl(162, 100%, 30%, 1)',
  iconMuted: 'hsl(var(--gray-500))',
} as { [key: string]: string }

export enum IconColor {
  white = 'white',
  primary = 'primary',
  lightGray = 'lightGray',
  darkPrimary = 'darkPrimary',
  secondary = 'secondary',
  tertiary = 'tertiary',
  muted = 'muted',
  aiGenerated = 'aiGenerated',
  success = 'success',
  iconMuted = 'iconMuted',
}

export function Icon({
  icon,
  color = IconColor.primary,
  size = 'lg',
  className,
  style,
  spin = false,
  ...rest
}: {
  icon: IconDefinition
  color?: IconColor | string
  size?: SizeProp
  className?: string
  style?: React.CSSProperties
  spin?: boolean
}): JSX.Element {
  return (
    <FontAwesomeIcon
      icon={icon}
      color={iconColor[color] ?? color}
      className={className}
      size={size}
      style={style}
      spin={spin}
      {...rest}
    />
  )
}
